import { useQuery } from "@tanstack/react-query";
import { GroupVisitControllerApi } from "@/services";
import { getConfigObject, getXtenantId } from "@/utils/utils";

export const GROUP_VISIT_THERAPISTS_QUERY_KEY = "group-visit-therapists";

/**
 * Therapist details for the providers assigned to a group.
 *
 * @author Rajkumar Rathod
 */
export const useGroupVisitTherapists = <T>(providerIds: string[] = []) =>
  useQuery({
    queryKey: [GROUP_VISIT_THERAPISTS_QUERY_KEY, providerIds],
    enabled: providerIds.length > 0,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new GroupVisitControllerApi(getConfigObject())
        .getTherapists(providerIds, getXtenantId())
        .then((res) => res?.data?.data as T),
  });
